export const BRL = (v) =>
  (Number(v) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits: 2 });

export const fmtDate = (iso) => (iso ? iso.slice(0, 10).split("-").reverse().join("/") : "—");

export const inputCls =
  "w-full h-10 px-3 rounded-xl border border-slate-200 bg-white text-slate-800 text-sm outline-none focus:ring-2 focus:ring-[#0A66C2]/40 focus:border-[#0A66C2] transition-[box-shadow,border-color]";

export const labelCls = "text-[11px] font-bold uppercase tracking-wide text-slate-500 mb-1 block";

export const btnPrimary =
  "inline-flex items-center justify-center gap-2 h-10 px-5 rounded-full bg-[#0A66C2] text-white text-sm font-bold hover:bg-[#08539e] active:scale-[0.98] transition-[background-color,transform] disabled:opacity-50";

export const btnGhost =
  "inline-flex items-center justify-center gap-2 h-10 px-4 rounded-full text-slate-600 text-sm font-semibold hover:bg-slate-100 transition-colors";

export const iconBtn =
  "h-8 w-8 inline-flex items-center justify-center rounded-full text-slate-400 hover:bg-slate-100 transition-colors";

export const Panel = ({ id, title, subtitle, action, children, testId }) => (
  <section id={id} className="scroll-mt-24 bg-white rounded-[28px] border border-[#EDE6DA] shadow-[0_1px_0_#EDE6DA] p-5 sm:p-7" data-testid={testId}>
    <div className="flex flex-wrap items-end justify-between gap-3 mb-5">
      <div>
        <h2 className="text-xl sm:text-2xl font-bold text-slate-900" style={{ fontFamily: "Fraunces, serif" }}>{title}</h2>
        {subtitle && <p className="text-sm text-slate-500 mt-0.5">{subtitle}</p>}
      </div>
      {action}
    </div>
    {children}
  </section>
);

export const StatusChip = ({ status }) => {
  const map = {
    pendente: "bg-amber-100 text-amber-800",
    confirmada: "bg-emerald-100 text-emerald-800",
    cancelada: "bg-red-100 text-red-700",
  };
  return (
    <span className={`text-[10px] font-bold uppercase px-2 py-0.5 rounded-full ${map[status] || "bg-slate-100 text-slate-600"}`}>
      {status === "pendente" ? "aguardando PIX" : status}
    </span>
  );
};
